export default {
  title: 'All courses',
  searchPH: 'Search by course name',
  noCourses: 'No courses found'
}



// WEBPACK FOOTER //
// ./src/i18n/courses/en.js